import { combineReducers } from "redux";
import User from "./user"
import Order from "./order"
import Stores from "./stores"



export default combineReducers({
  user: User,
  order: Order,
  stores: Stores
});